import { serializable, alias, primitive, object, list } from "serializr";
import { ClassroomModel } from "../ClassroomModel/classroom.model";

export class MetaModel {
  @serializable(alias("id", primitive()))
  value?: string;
  @serializable(alias("name", primitive()))
  label?: string;
}

export class SubjectModel {
  @serializable(alias("id", primitive()))
  id?: string;
  @serializable(alias("name", primitive()))
  name?: string;
  @serializable(alias("display_picture_url", primitive()))
  displayPictureUrl?: string;
  @serializable(alias("color_code", primitive()))
  colorCode?: string;
}

export class ClassRoomSubjectModel {
  @serializable(alias("id", primitive()))
  id?: string;
  @serializable(alias("subject_name", primitive()))
  name?: string;
  @serializable(alias("amount_paise", primitive()))
  amountPaise?: string;
  @serializable(alias("amount_rupees", primitive()))
  amountRupees?: string;
  @serializable(alias("amount", primitive()))
  amount?: number;
  @serializable(alias("is_active", primitive()))
  isActive?: boolean;
  @serializable(alias("chaptor_count", primitive()))
  chapterCount?: boolean;
  @serializable(alias("class_room", object(ClassroomModel)))
  classRoom?: string;
  @serializable(alias("subject_stream", object(MetaModel)))
  subjectStream?: string;
  @serializable(alias("subject_stream_id", primitive()))
  subjectStreamId?: string;
  @serializable(alias("subject", object(SubjectModel)))
  subject?: SubjectModel;
}
